// ============================================================================
// REGRAS DE SALDO — lógica pura, sem Firebase
// ============================================================================
//
// Vive num ficheiro à parte de `saldoUtilizador.js` porque não importa o
// Firestore: assim os testes correm em Node sem emulador e sem credenciais,
// tal como acontece com a vassoura das batalhas.
// Ver `scripts/test-saldo.mjs`.

export const FOTO_PADRAO = "https://cdn-icons-png.flaticon.com/512/5323/5323814.png";

// Um saldo pode chegar como texto de fichas antigas. `Number` com rede para
// nunca devolver NaN a quem vai fazer `.toLocaleString()` no render.
export const paraNumero = (valor) => {
  const n = Number(valor);
  return Number.isFinite(n) ? n : 0;
};

/**
 * Decide o que escrever numa ficha, dado o que já lá está.
 *
 * Está separada da transação de propósito: é aqui que vive a regra que o
 * cliente pediu ("nunca sobrepor saldos de uma ficha existente"), e assim ela
 * pode ser testada sem Firebase — como acontece com a vassoura das batalhas.
 * Ver `scripts/test-saldo.mjs`.
 *
 * @param {boolean} fichaExiste
 * @param {object|null} dadosExistentes
 * @param {{uid: string, displayName?: string, email?: string, photoURL?: string}} user
 * @param {{bolasIniciais?: number}} opcoes
 * @returns {{acao: 'criar'|'remendar'|'nada', escrita: object}}
 */
export function decidirEscritaDaFicha(fichaExiste, dadosExistentes, user, opcoes = {}) {
  const nomeDeReserva = user.displayName
    || (user.email ? user.email.split('@')[0] : "Adepto");

  // --- CAMINHO A: a ficha existe. O dinheiro é intocável. ---
  if (fichaExiste) {
    const dados = dadosExistentes || {};

    // Só se preenche o que estiver mesmo em falta, e NUNCA campos de saldo.
    // Uma escrita vazia significa que não se toca no documento de todo.
    const remendos = {};
    if (!dados.uid) remendos.uid = user.uid;
    if (!dados.nomeCompleto) remendos.nomeCompleto = nomeDeReserva;
    if (!dados.fotoUrl && !dados.photoURL) {
      remendos.fotoUrl = user.photoURL || FOTO_PADRAO;
    }

    return Object.keys(remendos).length > 0
      ? { acao: 'remendar', escrita: remendos }
      : { acao: 'nada', escrita: {} };
  }

  // --- CAMINHO B: primeiro registo. Só aqui entram valores por omissão. ---
  return {
    acao: 'criar',
    escrita: {
      uid: user.uid,
      nomeCompleto: nomeDeReserva,
      fotoUrl: user.photoURL || FOTO_PADRAO,
      saldoBolas: opcoes.bolasIniciais ?? 600000,
    },
  };
}

/**
 * Traduz um movimento nos campos que vão levar `increment()`, já saneados.
 *
 * Separada de `moverSaldo` para poder ser testada sem Firebase.
 *
 * `Number.isFinite` trava aqui os NaN que vinham de um preço em falta: um NaN
 * gravado no Firestore deixa o saldo irrecuperável, e já aconteceu nesta app.
 * Zeros também não são enviados — não têm efeito e só sujam a escrita.
 */
export function camposDoMovimento(movimento = {}) {
  const { 
    bolas = 0, 
    comissaoBolas = 0, 
    comissaoStickersBolas = 0, 
    comissaoPresentesVideoBolas = 0 
  } = movimento;
  
  const campos = {};

  if (Number.isFinite(bolas) && bolas !== 0) campos.saldoBolas = bolas;
  if (Number.isFinite(comissaoBolas) && comissaoBolas !== 0) campos.comissaoAppBolas = comissaoBolas;
  
  // 🎯 Adicionamos as tuas novas gavetas estratégicas à lista oficial:
  if (Number.isFinite(comissaoStickersBolas) && comissaoStickersBolas !== 0) campos.comissaoStickersBolas = comissaoStickersBolas;
  if (Number.isFinite(comissaoPresentesVideoBolas) && comissaoPresentesVideoBolas !== 0) campos.comissaoPresentesVideoBolas = comissaoPresentesVideoBolas;

  return campos;
}


